import React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import Signatur from "./Signatur";
import LoginButton from "./LoginButton";

const pca = new PublicClientApplication(msalConfig);

const App: React.FC = () => {
  return (
    <MsalProvider instance={pca}>
      {/* Visa login-knappen någonstans */}
      <LoginButton />
      {/* Och sedan själva signatur-komponenten */}
      <Signatur />
    </MsalProvider>
  );
};

export default App;
